// Mock data for Obsidian Chauffeurs

export const services = [
  {
    id: 'airport-transfer',
    title: 'Airport Transfer',
    slug: 'airport-transfer',
    description: 'Seamless airport transfers with flight monitoring and meet & greet service. Arrive relaxed and on time, every time.',
    fullDescription: 'Experience stress-free airport travel with our premium airport transfer service. We monitor your flight in real-time and adjust pickup times accordingly. Our professional chauffeurs provide meet and greet service, assist with luggage, and ensure you arrive at your destination in comfort and style. Available 24/7 for all major UK airports.',
    features: ['Flight monitoring', 'Meet & greet service', 'Luggage assistance', '24/7 availability', 'All major UK airports'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/6cb563129063cf5bde94aae92184728ecc0c36c2872154fbfdce22a2d912b221.png'
  },
  {
    id: 'corporate-travel',
    title: 'Corporate Travel',
    slug: 'corporate-travel',
    description: 'Professional chauffeur services for executives and business travellers. Punctual, discreet, and reliable.',
    fullDescription: 'Elevate your business travel with our executive chauffeur service. Perfect for client meetings, corporate events, and daily business transportation. Our experienced chauffeurs understand the importance of punctuality and discretion. Enjoy onboard WiFi, charging facilities, and a quiet environment to prepare for your next meeting.',
    features: ['Executive vehicles', 'Punctual service', 'Discreet chauffeurs', 'WiFi & charging', 'Account management'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/fab7f27bbd535087c2d5bdc15487bf52056fc0b21a6b31a0d979eaaa7f4fb559.png'
  },
  {
    id: 'sports-entertainment',
    title: 'Sports & Entertainment',
    slug: 'sports-entertainment',
    description: 'Football matches, horse races, gigs, live shows, concerts. VIP arrivals for the biggest & unforgettable events.',
    fullDescription: 'Make your event experience truly memorable with our VIP sports and entertainment chauffeur service. Whether it\'s Premier League football, Royal Ascot, sold-out concerts, or exclusive shows, we ensure you arrive in style. Enjoy pre-event refreshments and return home safely after the festivities.',
    features: ['VIP event transport', 'Pre-event refreshments', 'All major venues', 'Return journey included', 'Group bookings available'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/2977e1104a648b1fdfab47c0b8be84056320c4535de927f43127985816f2fcb0.png'
  },
  {
    id: 'production-events',
    title: 'Production & Events',
    slug: 'production-events',
    description: 'Reliable transport solutions for production crews, event staff, and equipment. On-time, every time.',
    fullDescription: 'Support your production or event with our dedicated transportation service. We understand the demanding schedules of the entertainment industry and provide reliable, flexible transport for crews, talent, and equipment. Multiple vehicle options available for various production needs.',
    features: ['Flexible scheduling', 'Multiple vehicle options', 'Equipment transport', 'Crew transportation', 'Long-term contracts'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/a02a48ddd8d431a288172588a65bd0d3dd79b8394bbcaf045393155848032796.png'
  },
  {
    id: 'long-distance-travel',
    title: 'Long Distance Travel',
    slug: 'long-distance-travel',
    description: 'Comfortable nationwide journeys in luxury vehicles. Travel your way, at your pace, in complete comfort.',
    fullDescription: 'Travel anywhere in the UK in ultimate comfort with our long-distance chauffeur service. Perfect for multi-city business trips, family occasions, or scenic tours. Our spacious Mercedes V-Class vehicles offer exceptional comfort for extended journeys, with refreshment stops and rest breaks as needed.',
    features: ['Nationwide coverage', 'Spacious vehicles', 'Refreshment stops', 'Flexible itineraries', 'Competitive rates'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/a679eb9da303fba429277a841fd08b55a184560d0abeaba31976fea390758984.png'
  },
  {
    id: 'personal-travel',
    title: 'Personal Travel',
    slug: 'personal-travel',
    description: 'Bespoke travel experiences tailored to your needs. Shopping trips, day outs, or special occasions.',
    fullDescription: 'Enjoy personalised chauffeur service for your personal travel needs. Whether it\'s a shopping trip to designer boutiques, a day out exploring the countryside, or visiting friends and family, we provide a tailored service that adapts to your schedule. Your personal chauffeur for the day.',
    features: ['Flexible itinerary', 'Wait & return service', 'Shopping assistance', 'Sightseeing tours', 'Hourly or daily rates'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/f180f3799e0ed63028360812f757480bac230611889891eb9df98259bf411940.png'
  },
  {
    id: 'special-occasions',
    title: 'Special Occasions',
    slug: 'special-occasions',
    description: 'Weddings, proms, anniversaries, and celebrations. Make your special day extraordinary with luxury transport.',
    fullDescription: 'Celebrate life\'s most precious moments with our special occasion chauffeur service. From weddings and proms to milestone anniversaries and romantic proposals, we add elegance and sophistication to your special day. Our vehicles are immaculately presented, and our chauffeurs ensure every detail is perfect.',
    features: ['Wedding packages', 'Prom nights', 'Anniversary celebrations', 'Decorated vehicles available', 'Red carpet service'],
    image: 'https://static.prod-images.emergentagent.com/jobs/78f5a82c-442c-401f-97ed-118ff3b2b080/images/d38e68fc1ae0194a4374d13936be945e84e3c190881f7812ec56c5c85f5380f3.png'
  }
];

export const fleet = [
  {
    id: 1,
    name: 'BMW i7',
    category: 'Electric First-Class Saloon',
    capacity: '3 passengers',
    luggage: '2-3 large suitcases',
    features: [
      '31" BMW Theatre Screen — 8K panoramic display',
      'Sky Lounge panoramic glass roof',
      'Fully electric — whisper-quiet ride',
      'Reclining executive rear seats',
      'Bowers & Wilkins surround sound',
      'Crystal-finish controls & ambient lighting',
    ],
    image: '/fleet/bmw-i7-exterior.webp',
    gallery: ['/fleet/bmw-i7-exterior.webp', '/fleet/bmw-i7-theatre.png'],
    description:
      'The all-electric BMW i7 is the pinnacle of modern executive travel. Recline into the rear cabin and lower the extraordinary 31-inch BMW Theatre Screen — an 8K panoramic display with cinema surround sound — while the Sky Lounge panoramic glass roof bathes the interior in soft, colour-shifting light. Silent, serene and impeccably appointed.',
  },
  {
    id: 2,
    name: 'Mercedes V-Class Exclusive',
    category: 'Luxury 6-Seat MPV',
    capacity: '6 passengers',
    luggage: '6-8 large suitcases',
    features: [
      'Cream nappa leather — six individual seats',
      'Starlight LED roof lining',
      'Folding conference table for corporate use',
      'Reclining captain seats',
      'Tinted privacy glass & climate control',
      'WiFi, USB-C charging & refreshments',
    ],
    image: '/fleet/v-class-exterior.jpg',
    gallery: [
      '/fleet/v-class-exterior.jpg',
      '/fleet/v-class-lineup.png',
    ],
    description:
      'Our Exclusive Mercedes V-Class is a first-class lounge on wheels. Six individual cream nappa leather seats sit beneath a shimmering starlight LED headliner, with a folding conference table that makes it ideal for corporate travel, roadshows, weddings and group journeys in complete comfort.',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'James Richardson',
    company: 'Corporate Executive',
    text: 'Obsidian Chauffeurs provides an exceptional service. Professional, punctual, and the vehicles are immaculate. My go-to for all business travel.',
    rating: 5
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    company: 'Event Organiser',
    text: 'Absolutely reliable for our high-profile events. The attention to detail and professionalism is outstanding. Highly recommended.',
    rating: 5
  },
  {
    id: 3,
    name: 'David Chen',
    company: 'Business Traveller',
    text: 'The best chauffeur service in the North West. Always on time, comfortable vehicles, and excellent drivers. Five stars.',
    rating: 5
  }
];

export const mockBooking = {
  submitBooking: async (bookingData) => {
    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Mock booking submitted:', bookingData);
        resolve({
          success: true,
          bookingId: `OC-${Date.now()}`,
          message: 'Your quote request has been received. We will contact you shortly with a quotation.'
        });
      }, 1500);
    });
  }
};
